import TitleBlockWrapper from '@anm/components/TitleBlock/Wrapper';
import ButtonWrapper from '@anm/components/buttons/Button/Button';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import { flexColumn, media } from '@anm/styles/helpers';
import styled from 'styled-components';

const CancelSubscriptionModalWrapperTablet = media.tablet`
  max-width: 100%;
  height: 100%;
`;

export const ButtonLink = styled(ButtonLoader)<{ active?: boolean }>`
  font-weight: 700;
  text-decoration: underline;

  color: ${({ active }) => (active ? '#30AEF2' : '#BCC6CC !important')};
  &,
  * {
    cursor: ${({ active }) => (active ? 'pointer' : 'default')};
  }
`;

export const CancelSubscriptionModalWrapper = styled.div`
  ${flexColumn};
  max-width: 500px;
  line-height: 32px;
  pointer-events: auto;
  padding: 32px;
  > ${TitleBlockWrapper} {
    padding: 14px 46px 18px;
    text-align: center;
  }
  ${CancelSubscriptionModalWrapperTablet};
`;

export const DowngradeButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 0;
  margin-top: 14px;
  ${ButtonWrapper} {
    font-size: 16px;
  }
`;
